var swiper = new Swiper(".block__event-pre-order-product-slider", {
    slidesPerView: 1,
    autoHeight: true,
    mousewheel: {
        forceToAxis: true,
    },
    navigation: {
        nextEl: '.swiper-buttons-next',
        prevEl: '.swiper-buttons-prev',
    },
});


var swiper = new Swiper(".block__everyday-big-sale-slider", {
    slidesPerView: 1,
    autoHeight: false,
    effect:'fade',
    loop:true,
    mousewheel: {
        forceToAxis: true,
    },
    navigation: {
        nextEl: '.swiper-buttons-next',
        prevEl: '.swiper-buttons-prev',
    },
});